import React from "react"
import SeminarTypes from "./seminar/seminar-types"
import SeminarStatus from "../components/seminar/seminar-status"
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"
import { Link } from 'gatsby'
import { colorCode } from "../functions/middle-category-style"

export default function RelatedComponents({
  relatedPrograms,
  relatedSeminars,
  relatedBooks,
  relatedArticles
}) {
  return (
    <>
      { Object.keys(relatedPrograms).length ?
      <>
      <div className="contents_02">
        <div className="contents_in">
          <div className="padding_sp">{/* スマホのみ隙間 */}
            <div className="inner_title">
              <div className="inner_title_in">
                <h4 className="maintitle"><span>Related Program</span></h4>
                <p className="subtitle"><span>関連するプログラム</span></p>
              </div>
            </div>
            <div className="publication_wrap">
              <ul className="publication_box">
                {relatedPrograms.map((program) => (
                  <li key={program.id}>
                    <Link to={'/program/' + program.id} >
                      <div className="box_gray">
                      <LazyAndPreloadImage imgUrl={program.thumbnail ? program.thumbnail.url : ''} alt="プログラムサムネイル" />
                      </div>
                      <p className="program_title">{program.title}</p>
                      <p className="program_detail">{program.subtitle}</p>
                      <div className="tag_list">
                        { Object.keys(program.task_tags).length ?
                          program.task_tags.map((task, index) => {
                              if(task.type !== undefined ) {
                                return task.type[0] === "プログラムタグ" ? <a key={task.id + index}>#{task.name}</a> : ''
                              }
                            }
                          )
                          : ''
                        }
                        { Object.keys(program.hierarchy_tags).length ?
                          program.hierarchy_tags.map((task, index) => {
                            if(task.type !== undefined ) {
                              return task.type[0] === "プログラムタグ" ? <a key={task.id + index}>#{task.name}</a> : ''
                            }
                          }
                        )
                          : ''
                        }
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>{/* padding_sp スマホのみ隙間 */}
        </div>{/* contents_in */}
      </div>{/* /contents */}
      </>
      : ''
      }
      { Object.keys(relatedSeminars).length ?
      <>
      <div className="contents_02">
        <div className="contents_in">
          <div className="padding_sp">{/* スマホのみ隙間 */}
            <div className="inner_title">
              <div className="inner_title_in">
                <h4 className="maintitle"><span>Related Seminar</span></h4>
                <p className="subtitle"><span>関連するセミナー</span></p>
              </div>
            </div>
            <div className="publication_wrap">
              <ul className="publication_box seminar_box">
                {relatedSeminars.map((seminar) => (
                  <li key={seminar.id}>
                    <SeminarStatus status={seminar.status} />
                    <Link to={'/seminar/' + seminar.id} >
                      <div className="box_gray">
                        <LazyAndPreloadImage imgUrl={seminar.image ? seminar.image.url : ''} alt="セミナサムネイル" />
                        
                      </div>
                      <SeminarTypes types={seminar.types} />
                      <p className="seminar_title">{seminar.title}</p>
                      <div className="data">開催日程：{seminar.display_event_date}</div>
                      <div className="seminar_tag">
                        {seminar.tags.map((tag) => {
                          if(tag.type !== undefined) {
                            return tag.type[0] === "セミナータグ" ? <p key={tag.id}>#{tag.name}</p> : ''
                          }
                        })}
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>{/* padding_sp スマホのみ隙間 */}
        </div>{/* contents_in */}
      </div>{/* /contents */}
      </>
      : ''
    }
    { Object.keys(relatedBooks).length ?
      <>
      <div className="contents_02">
        <div className="contents_in">
          <div className="padding_sp">{/* スマホのみ隙間 */}
            <div className="inner_title">
              <div className="inner_title_in">
                <h4 className="maintitle"><span>Related Book</span></h4>
                <p className="subtitle"><span>合わせておすすめしたい書籍</span></p>
              </div>
            </div>
            <div className="publication_wrap">
              <ul className="publication_box">
                {relatedBooks.map((book) => (
                  <li key={book.id}>
                    <Link to={'/publication/book/' + book.id} >
                      <div className="box_gray">
                        <LazyAndPreloadImage imgUrl={book.display_image ? book.display_image.url : ''} alt="書籍サムネイル" />
                      </div>
                      <p>{book.title}</p>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>{/* padding_sp スマホのみ隙間 */}
        </div>{/* contents_in */}
      </div>{/* /contents */}
      </>
      : ''
    }
      <div className="contents_02">
        <div className="contents_in">
          <div className="padding_sp">{/* スマホのみ隙間 */}

    { Object.keys(relatedArticles).length ?
            <div className="inner_title no_flex">
              <div className="inner_title_in">
                <h4 className="maintitle"><span>Related Article</span></h4>
                <p className="subtitle"><span>合わせて読むのにおすすめな記事</span></p>
              </div>
            <div className="publication_wrap related_Article">
              <ul className="publication_box seminar_box">
              {relatedArticles.map((article) => (
                <li key={article.id} className="flex_contents">
                  <div className="contents_box">
                    <Link className="note_box_img" to={'/note/' + article.id}><LazyAndPreloadImage imgUrl={article.thumbnail ? article.thumbnail.url : ''} alt={"ノート"} /></Link>
                  </div>
                    { article.middle_category ?
                      <Link to={'/note/category/' + article.middle_category.name}>
                        <div className="dayicon series" style={{background: colorCode(article.middle_category.display_color ? article.middle_category.display_color[0] : '')}}>
                          {article.middle_category.name}
                        </div>
                      </Link>
                      : ''
                    }
                  <Link to={'/note/' + article.id}><p className="note_category_title">{article.title}</p></Link>
                  <ul className="tag_list">
                  {article.tags.map((tag) => {
                    if(tag.type !== undefined) {
                      return tag.type[0] === "ノートタグ" ? <li key={tag.id}><Link to={'/note/tag/' + tag.name}>#{tag.name}</Link></li> : ''
                    }
                  })}
                  </ul>
                </li>
              ))}
              </ul>
            </div>
            </div>
      : ''
    }
          </div>{/* padding_sp スマホのみ隙間 */}
        </div>{/* contents_in */}
      </div>{/* /contents */}
    </>
  )
}
